// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3Z8mi","itemTitle":"ClientEmergencyInfo_itemTitle__coW4h","itemText":"ClientEmergencyInfo_itemText__3AVHy"};